import React, { Component } from "react";
import "./index.less";
import { Button } from "antd";
import { mationData } from "./const";
export default class Journ extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  centerRender = () => {
    let quTye =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.mationType;

    let renderData = mationData.filter((item) => {
      return item.type == quTye;
    });
    if (renderData.length > 0) {
      return renderData[0].render();
    }
  };
  render() {
    return (
      <div className="Journ-wrap">
        <div className="JournCont">{this.centerRender()}</div>
      </div>
    );
  }
}
